
define(
	'Code25.Login'
	, [
		"underscore", "jQuery","Profile.Model"
	]
	, function (
		_, jQuery,ProfileModel
	) {
		'use strict';

		return {
            mount: function (container) {
				console.log("Stay logged in.");

                var LiveOrderModel = require('LiveOrder.Model');

				if (ProfileModel.ProfileModel) {
					ProfileModel = ProfileModel.ProfileModel;
				  }

				window.setInterval(function () {

					try {

						var isLoggedIn = ProfileModel.getInstance().get('isLoggedIn') === 'T';
						if(isLoggedIn){
						var model = LiveOrderModel.getInstance();

						model.fetch();
						console.log("Logged in.");
						}
					} catch (err) {

					}
				}, 1000 * 60 * 5);
					

            }
        };

	});
